import React from 'react';
import withAppState from '../mobx/withAppState';
import { getCsrfToken } from '../helpers/GetCsrfToken';

class PreOrderMenuDataCapture extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customerData: {
                firstName: '',
                emailAddress: '',
                mobileNumber: '',
                pizzaExpressTermsAndConditionsAgreed: false,
                optIn: false,
                trackAndTraceAgreed: true,
                over16: true,
                restaurantId: props.restaurant.id,
            },
            results: null,
            loading: true,
            firstNameEmpty: false,
            firstNameValid: true,
            mobileNoEmpty: false,
            mobileNoValid: true,
            emailEmpty: false,
            emailValid: true,
            showTAndCError: false,
            errors: null
        };

    }

    componentDidMount() {
        this.setState({
            loading: false
        });
    }

    toggleErrorModal = () => {
        this.setState({ errors: null })
    }

    handleFocus = e => {
        var element = e.target;
        element.scrollIntoView({
            block: 'center',
            inline: 'nearest'
        });
    };

    handleChange(e, fieldName) {

        const { customerData } = this.state;

        switch (fieldName) {
            case "firstName":
                customerData.firstName = e.currentTarget.value.trim();
                break;
            case "emailAddress":
                customerData.emailAddress = e.currentTarget.value.trim();
                break;
            case "mobileNumber":
                customerData.mobileNumber = e.currentTarget.value.trim();
                break;
        }
        this.setState({ customerData });
    }

    validateField(fieldName) {
        const { customerData } = this.state;
        const { allowIrishPhoneNumbers } = this.props;
        let valid = false;

        switch (fieldName) {
            case "firstName":

                const feRe = /^[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF a-zA-Z0-9_,.'-]*$/i;
                valid = feRe.test(customerData.firstName.trim());
                this.setState({
                    firstNameValid: valid,
                    firstNameEmpty: false
                })

                break;
            case "emailAddress":
                const eaRe = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                valid = eaRe.test(customerData.emailAddress.trim());
                this.setState({
                    emailValid: valid,
                    emailEmpty: false
                })

                break;
            case "mobileNumber":
                valid = this.isValidPhonenumber(customerData.mobileNumber.trim());
                this.setState({
                    mobileNoValid: valid,
                    mobileNoEmpty: false
                })

                break;
        }
        this.setState({ customerData });
        return valid;
    };

    
    isValidPhonenumber(value) {
        return (/^\d{7,}$/).test(value.replace(/[\s()+\-\.]|ext/gi, ''));
    }
    toggleTandC() {
        const { customerData } = this.state;
        customerData.pizzaExpressTermsAndConditionsAgreed = !customerData.pizzaExpressTermsAndConditionsAgreed;
        this.setState({ customerData });
        this.setState({ showTAndCError: !customerData.pizzaExpressTermsAndConditionsAgreed });
    };

    toggleOptIn() {
        const { customerData } = this.state;
        customerData.optIn = !customerData.optIn;
        this.setState({ customerData });
    };

    toggleTestAndTrace() {
        const { customerData } = this.state;
        customerData.trackAndTraceAgreed = !customerData.trackAndTraceAgreed;
        this.setState({ customerData });
    }

    formIsValid() {
        var isValid = true;
        const { customerData } = this.state;

        //check email 
        if (!customerData.emailAddress) {
            this.setState({ emailEmpty: true });
            isValid = false;
        }
        else {
            isValid  = this.validateField("emailAddress");
            this.setState({ emailEmpty: false });
        }
        //check first name
        if (!customerData.firstName) {
            this.setState({ firstNameEmpty: true });
            isValid = false;
        }
        else {
            isValid = this.validateField("firstName");
            this.setState({ firstNameEmpty: false });
        }
        //check mobile number
        if (!customerData.mobileNumber && customerData.trackAndTraceAgreed) {
            this.setState({ mobileNoEmpty: true });
            isValid = false;
        }
        else {
            isValid = this.validateField("mobileNumber");
            this.setState({ mobileNoEmpty: false });
        }
        //check T & C
        if (!customerData.pizzaExpressTermsAndConditionsAgreed) {
            this.setState({ showTAndCError: true });
            isValid = false;
        }
        else {
            this.setState({ showTAndCError: false });
        }

        return isValid;
    }

    async continueButtonHandler(skip) {

        if (skip) {
            this.props.continueButtonHandler();
        }
        else {
            if (this.formIsValid()) {
                this.setState({ loading: true });

                const response = await fetch(`api/DataCapture/DataCapture`, {
                    method: 'post',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': getCsrfToken()
                    },
                    body: JSON.stringify(this.state.customerData)
                });

                let data;
                try {
                    data = await response.json()
                    if (data.code == 200) {
                        this.props.setDataCaptureStatusForCurrentRestaurant(true);
                        this.props.continueButtonHandler();
                    }
                    else {
                        this.setState({
                            errors: ["We could not check you in at this time. Please try later."]
                        });
                        this.setState({ loading: false });
                        return;
                    }

                }
                catch (err) {
                    console.error(err);
                    this.setState({
                        errors: ["We could not check you in at this time. Please try later."]
                    });
                    this.setState({ loading: false });
                    return;
                }
            }
        }
    }


    render() {
        const {
            loading,
            customerData: {
                optIn,
                firstName,
                emailAddress,
                mobileNumber,
                trackAndTraceAgreed,
                pizzaExpressTermsAndConditionsAgreed,
            },
            errors,
            firstNameEmpty,
            firstNameValid,
            emailEmpty,
            emailValid,
            mobileNoEmpty,
            mobileNoValid,
            showTAndCError,
        } = this.state;


        return (
            <div className="menu-page checkin">
                <div className={`company-header-wrapper`}>
                    <div className={`error-modal-bg ${!!errors ? 'open' : 'closed'}`} onClick={() => this.toggleErrorModal()}></div>
                    <div className={`error-container ${errors ? 'open' : 'closed'}`}>
                        <div className="error-popup alerting">
                            <div className="error-popup-content">
                                <div className="error-popup-content-inner">
                                    <p>{errors}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`company-logo-wrapper static`}>
                        {this.props.logo}
                    </div>
                </div>

                <div className="menu large-header">

                    <div className="checkin-card intro">
                        <div className="checkin-card-intro-inner">
                            <div className="checkin-card-title">
                                <div className="checkin-card-title-inner">
                                    <h3>Check in</h3>
                                    <p>To get started please fill in a few essential details:</p>
                                </div>
                            </div>
                            <div className="checkin-card-action-wrapper">
                                <div className="checkin-card-action-inner">
                                    <div className="checkin-input-wrapper">
                                        <input
                                            id="firstName"
                                            type="text"
                                            tabIndex="1"
                                            value={firstName}
                                            placeholder="First name"
                                            onFocus={e => this.handleFocus(e)}
                                            onChange={e => this.handleChange(e, "firstName")}
                                        />
                                        <div className={`warning-wrapper ${firstNameEmpty || !firstNameValid ? 'open' : ''}`}>
                                            {firstNameEmpty && (
                                                <p id="firstname-warning" className="warning">
                                                    Please enter your name
                                                </p>
                                            )}
                                            {!firstNameValid && (
                                                <p id="firstname-warning" className="warning">
                                                    First name only accepts ', - and letters.
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="checkin-input-wrapper">
                                        <input
                                            id="emailAddress"
                                            type="text"
                                            tabIndex="2"
                                            placeholder="Email address"
                                            value={emailAddress}
                                            onFocus={e => this.handleFocus(e)}
                                            onChange={e => this.handleChange(e, "emailAddress")}
                                        />
                                        <div className={`warning-wrapper ${emailEmpty || !emailValid ? 'open' : ''}`}>
                                            {(emailEmpty || !emailValid) && (
                                                <p id="email-warning" className="warning">
                                                    Please enter a valid email address.
                                                </p>
                                            )}
                                        </div>

                                    </div>
                                    <div className="checkin-input-wrapper mobile">
                                        <input
                                            id="mobileNumber"
                                            type="text"
                                            minLength="11"
                                            maxLength="15"
                                            tabIndex="3"
                                            placeholder="Phone number"
                                            value={mobileNumber}
                                            onFocus={e => this.handleFocus(e)}
                                            onChange={e => this.handleChange(e, "mobileNumber")}
                                        />
                                        <div className={`warning-wrapper ${trackAndTraceAgreed && (mobileNoEmpty || !mobileNoValid) ? 'open' : ''}`}>
                                            {(trackAndTraceAgreed && (!mobileNoValid || mobileNoEmpty)) && (
                                                <p id="mobile-warning" className="warning">
                                                    Please enter a valid phone number.
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="checkin-card-checkbox-wrapper">
                                        <label className="checkin-card-checkbox-inner">
                                            <div className="checkin-card-checkbox-input">
                                                <input
                                                    type="checkbox"
                                                    id="tandC"
                                                    tabIndex="4"
                                                    checked={pizzaExpressTermsAndConditionsAgreed}
                                                    onChange={() => this.toggleTandC()}
                                                />
                                            </div>
                                            <div className="checkin-card-checkbox-copy">
                                                <p>I have read and agreed to the <a onClick={() => this.props.termAndConditionsWebModalMenu()}>T&Cs</a> of this website and <a onClick={() => this.props.privacyPolicyWebModalMenu()}>privacy policy</a></p>
                                            </div>
                                        </label>
                                        <label className="checkin-card-checkbox-inner">
                                            <div className="checkin-card-checkbox-input">
                                                <input
                                                    type="checkbox"
                                                    id="pizzaExpressTermsAndConditionsAgreed"
                                                    tabIndex="5"
                                                    checked={optIn}
                                                    onChange={() => this.toggleOptIn()}
                                                />
                                            </div>
                                            <div className="checkin-card-checkbox-copy">
                                                <p>Tick here to be added to our email list to receive fantastic offers and news from PizzaExpress owned Companies</p>
                                            </div>
                                        </label>
                                        <div className={`warning-wrapper ${showTAndCError || !!errors ? 'open' : ''}`}>
                                            {showTAndCError && (
                                                <p className="tandc-error warning">
                                                    You must agree to Terms and Conditions to continue. If you do not agree, please skip.
                                                </p>
                                            )}
                                            {!!errors &&
                                                errors.map((error, index) => {
                                                    return (
                                                        <p key={index} className="warning">
                                                            {error.description}
                                                        </p>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                    <div className="checkin-card-checkbox-wrapper">

                                        <div className="checkin-card-title-inner">
                                            <h4>{this.props.testAndTraceTitle}</h4>
                                            <p>{this.props.testAndTraceDescription}<a onClick={() => this.props.privacyPolicyWebModalMenu()}>privacy policy</a> and <a onClick={() => this.props.termAndConditionsWebModalMenu()}>Ts&Cs</a></p>
                                        </div>
                                        <label className="checkin-card-checkbox-inner hidden">
                                            <div className="checkin-card-checkbox-input">
                                                <input
                                                    checked={trackAndTraceAgreed}
                                                    type="checkbox"
                                                    id="trackAndTraceAgreed"
                                                    tabIndex="6"
                                                    onChange={() => this.toggleTestAndTrace()}
                                                />
                                            </div>
                                            <div className="checkin-card-checkbox-copy">
                                                <p>Include me in NHS Test and Trace</p>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="checkin-card content">
                        <div className="checkin-card-content-inner">
                            <p>By clicking continue you are confirming you are over 18</p>
                        </div>
                    </div>

                    <div className="checkin-card">
                        <div className="checkin-card-content-inner">
                            <div className="checkin-buttons">
                                <button
                                    tabIndex="7"
                                    className="menu-cta primary-cta continue-button"
                                    onClick={() => this.continueButtonHandler(false)}
                                >
                                    {loading && (<div className={`lds-dual-ring main-loading`}></div>)}
                                    Submit
                    </button>
                                {!this.props.hideSkip &&
                                    <button
                                        tabIndex="8"
                                        className="menu-cta secondary-cta skip-button"
                                        onClick={() => this.continueButtonHandler(true)}
                                    >
                                        Skip
                    </button>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        );

    }
}



export default withAppState(PreOrderMenuDataCapture,
    {
        mobXProps: ({
            restaurant,
            privacyPolicyAndTermsConditionsModal,
            privacyPolicyAndTermsConditionsModalMenu,
            termAndConditionsCopy,
        }) => ({
            restaurant,
            privacyPolicyAndTermsConditionsModal,
            privacyPolicyAndTermsConditionsModalMenu,
            termAndConditionsCopy,
        }),
        mobXActions: ({
            logout,
            termAndConditionsModal,
            termAndConditionsWebModalMenu,
            privacyPolicyWebModalMenu,
            closePrivacyPolicyTermsAndConditionsModal,
            setDataCaptureStatusForCurrentRestaurant
        }) => ({
            logout,
            termAndConditionsModal,
            termAndConditionsWebModalMenu,
            privacyPolicyWebModalMenu,
            closePrivacyPolicyTermsAndConditionsModal,
            setDataCaptureStatusForCurrentRestaurant,
        })
    }
);








